var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classes},[_vm._v("\n  "+_vm._s(_vm.data.label)+"\n  "),(_vm.showArrow)?_c('y-icon',{class:(_vm.prefix + "-arrow"),attrs:{"name":"right"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }